import { useEffect, useState } from "react";
import ProductPlacementManager from "@/pages/admin/components/ProductPlacementManager";
import { useSiteSettings } from "@/hooks/useSiteSettings";

export default function AdminHighlights() {
  const { settings, updateSettings } = useSiteSettings();
  const [homeDescription, setHomeDescription] = useState(settings.homeFeaturedDescription);

  useEffect(() => {
    setHomeDescription(settings.homeFeaturedDescription);
  }, [settings.homeFeaturedDescription]);

  const saveHomeDescription = () => {
    const nextValue = homeDescription.trim();
    setHomeDescription(nextValue);
    updateSettings({ homeFeaturedDescription: nextValue });
  };

  return (
    <ProductPlacementManager
      title="Produtos em Destaque"
      subtitle="Gerencie a vitrine principal da home a partir do cadastro do produto"
      flag="showInFeatured"
      icon="ri-star-line"
      enabledLabel="Produto em Destaque"
      enabledDescription="Ative ou desative por aqui quais produtos do cadastro aparecem na seção Produtos em Destaque. Para cadastrar um novo item, use a tela de produtos."
      emptyLabel="Nenhum produto encontrado para este filtro"
      topContent={
        <div className="mb-6 rounded-3xl border border-gray-100 bg-white p-5 md:p-6">
          <div className="flex items-start justify-between gap-4 flex-wrap mb-4">
            <div>
              <h2 className="text-lg font-black text-gray-900 flex items-center gap-2">
                <i className="ri-text text-orange-500"></i>
                Texto abaixo de Produtos em Destaque na Home
              </h2>
              <p className="text-sm text-gray-500 mt-1">
                O texto salvo aqui será exibido logo abaixo do título da seção Produtos em Destaque em /.
              </p>
            </div>
            <button
              onClick={saveHomeDescription}
              className="px-4 py-2.5 rounded-xl bg-orange-500 text-white text-sm font-bold hover:bg-orange-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-save-line mr-1.5"></i>Salvar texto
            </button>
          </div>

          <textarea
            value={homeDescription}
            onChange={(e) => setHomeDescription(e.target.value)}
            rows={3}
            className="w-full rounded-2xl border border-gray-200 px-4 py-3 text-sm resize-none focus:outline-none focus:border-orange-400 focus:ring-2 focus:ring-orange-100"
            placeholder="Digite o texto exibido abaixo do título da seção na Home"
          />
        </div>
      }
    />
  );
}
